import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllLabellingResponseModel, LabellingDto, LabellingResponseModel } from '@gtpl/shared-models/production-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Raw, Repository } from 'typeorm';
import { LabellingAdapter } from './dto/labelling.adapter';
import { LabellingData } from './dto/labelling.dto';
import { LabellingIdRequest } from './dto/labelling-id-request';
import { Labelling } from './entities/labelling.entity';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { LabellingSamples } from './entities/labelling-samples.entity';
import { LabellingRepository } from './repositories/labelling.repository';
import appSettings from 'apps/services/config';
import { combineAll } from 'rxjs/operators';
import { isIBAN } from 'class-validator';
const labellingTable = appSettings.production_db + '.labelling'
const salesSoTable = appSettings.sales_db + '.sale_order';
const salesSoItemTable=appSettings.sales_db + '.sale_order_items'




@Injectable()
export class LabellingService {
    constructor(
        private labellingRepository: LabellingRepository,
        private labellingAdapter: LabellingAdapter,

    ) { }


    /**
     * 
     * @param testDto 
     * @param isUpdate 
     * @returns created Data
     */
    async getLabellingDetailsWithoutRelations(saleOrderId: number,saleOrderItemId:number): Promise<Labelling> {
        // tslint:disable-next-line: typedef
        const labellingResponse = await this.labellingRepository.findOne({
            where: { saleOrderId: saleOrderId,saleOrderItemId:saleOrderItemId },
        });
        if (labellingResponse) {
            return labellingResponse;
        } else {
            return null;
        }
    }

    async createLabelling(labellingDto: LabellingData, isUpdate: boolean): Promise<LabellingResponseModel> {
        console.log("labellingDto,",labellingDto)
        console.log('isUpdate',isUpdate)
        try {
            console.log('isUpdate',isUpdate)
            if (!isUpdate) {
                
                const labellingEntity = await this.getLabellingDetailsWithoutRelations(labellingDto.saleOrderId,labellingDto.saleOrderItemId);
                if (labellingEntity) {
                    //return new InformationMessageError(11104, "State already exists");
                    throw new ErrorResponse(11104, 'Labelling already exists');
                }
            }
            else {
                const labellingEntity = await this.getLabellingDetailsWithoutRelations(labellingDto.saleOrderId,labellingDto.saleOrderItemId);
                if (labellingEntity) {
                    if (labellingEntity.labellingId != labellingDto.labellingId) {
                        throw new ErrorResponse(11104, 'Labelling already exists');
                    }
                }
            }
            const convertedEntity: Labelling = this.labellingAdapter.convertDtoToEntity(labellingDto);
            const savedEntity: Labelling = await this.labellingRepository.save(
                convertedEntity
            );

            if (savedEntity) {
                // generating resposnse
                const response = new LabellingResponseModel(true, 1, isUpdate ? 'Labelling Updated Successfully' : 'Labelling Created Successfully');
                return response;

            } else {
                //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
                throw new ErrorResponse(11106, 'Labelling saved but issue while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            return error;
        }
    }

    async getAllLabellings(): Promise<AllLabellingResponseModel> {
        try {
            const manager = getManager()
            const query = `SELECT s.saleOrder_Id as saleOrderId,s.saleorder_item_id as saleOrderItemId,s.labelling_date as labellingDate,s.labelling_id as labellingId,s.lot_number as lotNumber,so.sale_order_no as soNumber,  concat(b.brand_name, "/", p.name, "/", soi.min_grade_id,'-',soi.max_grade_id) as item,traceability_code as traceabilityCode, s.country, s.totalMCs FROM ` + labellingTable + ` s 
            LEFT JOIN ` + salesSoItemTable + ` soi ON soi.sale_order_item_id=s.saleorder_item_id 
            LEFT JOIN ` + salesSoTable + ` so ON so.sale_order_id=s.saleOrder_Id
            LEFT JOIN ` + appSettings.masters_db + `.brands b ON b.brand_id=soi.brand_id
            LEFT JOIN `+ appSettings.masters_db + `.products p ON p.product_id=soi.item_id
            LEFT JOIN `+ appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=soi.varient_id
            ORDER BY  labelling_id ASC` 
            const qEntities: LabellingData[] = await manager.query(query)
            if (qEntities) {
                const response = new AllLabellingResponseModel(true, 1, 'Labelling retrieved successfully', qEntities);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            console.log(err)
            return err;
        }
    }
    async getAllActiveLabellings(): Promise<AllLabellingResponseModel> {
        // const page: number = 1;
        try {
            const query = 'SLECT '
            const qDtos: LabellingData[] = [];
            //retrieves all companies
            const qEntities: Labelling[] = await this.labellingRepository.find({
                order: { traceabilityCode: 'ASC' },
            });
            console.log(qEntities)
            if (qEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                qEntities.forEach(Entity => {
                    const convertedDto: LabellingData = this.labellingAdapter.convertEntityToDto(
                        Entity
                    );
                    qDtos.push(convertedDto);
                });
                const response = new AllLabellingResponseModel(true, 11108, "Labelling retrieved successfully", qDtos);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }

    async activateOrDeactivateLabelling(qReq: LabellingIdRequest): Promise<LabellingResponseModel> {
        try {
            const qExists = await this.getLabellingById(qReq.labellingId);
            if (qExists) {
                if (qReq.versionFlag !== qExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Labelling information.Refresh and try again');
                } else {

                    const qStatus = await this.labellingRepository.update(
                        { labellingId: qReq.labellingId },
                        { isActive: qReq.isActive, updatedUser: qReq.updatedUser });

                    if (qExists.isActive) {
                        if (qStatus.affected) {
                            const labellingResponse: LabellingResponseModel = new LabellingResponseModel(true, 10115, 'Labelling is de-activated successfully');
                            return labellingResponse;
                        } else {
                            throw new ErrorResponse(10111, 'Labelling is already deactivated');
                        }
                    } else {
                        if (qStatus.affected) {
                            const labellingResponse: LabellingResponseModel = new LabellingResponseModel(true, 10114, 'Labelling is activated successfully');
                            return labellingResponse;
                        } else {
                            throw new ErrorResponse(10112, 'Labelling is already  activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getLabellingById(labellingId: number): Promise<Labelling> {
        const response = await this.labellingRepository.findOne({
            where: { labellingId: labellingId },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async createLabellingInfo(labellingInfo: LabellingData): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            if(!labellingInfo.labellingId){
                const labellingEntity = await this.getLabellingDetailsWithoutRelations(labellingInfo.saleOrderId,labellingInfo.saleOrderItemId);
                if (labellingEntity) {
                    //return new InformationMessageError(11104, "State already exists");
                    throw new ErrorResponse(11104, 'Labelling already exists');
                }
            }
            
           const convertedDtoRmE = await this.labellingAdapter.convertDtoToEntity(labellingInfo);
            await manager.startTransaction();
            const savedInfoRmE = await manager.getCustomRepository(LabellingRepository).save(convertedDtoRmE);

            if (savedInfoRmE) {
                manager.completeTransaction();
                return new CommonResponse(true, 1111, 'Labelling along with Samples Info are created successfully');
            } else {
                throw new ErrorResponse(9999, 'Creation of Labelling failed');
            }
        }
         catch (error) {
            manager.releaseTransaction();
            return error;
        }
    }

    async getAllLabellingSamplesForLabelId(qReq: LabellingIdRequest): Promise<LabellingResponseModel> {
        try {
            const qDtos: LabellingData[] = [];
            const qEntities: Labelling = await this.labellingRepository.findOne({ where: { labellingId: qReq.labellingId }, relations: ['labellingSamplesInfo'] });
           console.log("test",qReq.labellingId)
            if (qEntities) {
                const convertedDto: LabellingData = this.labellingAdapter.convertEntityToLabelDto(
                    qEntities
                );
                const response = new LabellingResponseModel(true, 1, 'Labelling retrieved successfully', convertedDto);
                return response;
            } else {
                
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            return err;
        }
    }


}
